export default "__VITE_ASSET__Cfn3yBrD__"